import { render } from "./UserServices.vue?vue&type=template&id=1928e512&scoped=true"
import script from "./UserServices.vue?vue&type=script&lang=js"
export * from "./UserServices.vue?vue&type=script&lang=js"

import "./UserServices.vue?vue&type=style&index=0&id=1928e512&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1928e512"]])

export default __exports__